import React, { Component, KeyboardEvent, ChangeEvent, MouseEvent } from "react";
import {
    Tooltip, Button, Modal, ModalBody, ModalHeader, ModalFooter 
} from "reactstrap";
import * as KSLPlusAPI from "../services/KSLPlusAPI"



import Select from 'react-select';

type State = {    
    isOpen: boolean,
    value: any
}

type Props = {
    filterOptions: any[],
    column: {},    
    onFilter: (value: any) => void,
    selected: any,    
    multiSelect: boolean

}

const selectStyles = {
    //control: (provided: any) => ({ ...provided, minWidth: 240, margin: 8 }),
    //menu: () => ({ boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)' }),
};


export class SelectSearchFilter extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        
    }

    
    static defaultProps = {
        multiSelect: false   
    }

    state: State = {
        isOpen: true,
        value: undefined 
    }

    toggleOpen = () => {
        this.setState(state => ({ isOpen: !state.isOpen }));        
    };
    onSelectChange = (value:any) => {
        this.toggleOpen();
        this.setState({ value });            
        this.props.onFilter(value);
    };
    
    
    render() {
        const { isOpen, value } = this.state;

        return (
            
            <Select                
                backspaceRemovesValue={false}
                components={{ IndicatorSeparator: null }}
                controlShouldRenderValue={true}
                hideSelectedOptions={false}
                isClearable={true}
                className="kslplus-select-search-filter "
                onChange={this.onSelectChange}
                options={this.props.filterOptions}
                placeholder="Filter"
                styles={selectStyles}
                tabSelectsValue={true}
                isMulti={this.props.multiSelect}
                value={this.props.selected}
            />            
        );
    }
    
}
